import logWarningInDev from '../../helpers/logWarningInDev';
import PaginationProvider from './PaginationProvider';
export default PaginationProvider;
logWarningInDev(true, 'This component has been renamed to PaginationProvider. Please update your imports.');
//# sourceMappingURL=PaginationContainer.js.map